import {Formula} from "./../../models/Formula";
import {WrapperFactory} from "../WrapperFactory";

let formulasApi = {
    async get(token, companyId,params={}){
        let response = await window.axios.get('/api/formulas', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });

        let wrapper = WrapperFactory.fromResponse(response.data)
        wrapper.transform(e=>new Formula(e));
        return wrapper;
    },
    async find(id, token, companyId, params={}){
        let response = await window.axios.get('/api/formulas/'+id, {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data;
    },
    async create(formula, token, companyId, params = {}){
        let response = await window.axios.post('/api/formulas', formula, {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return new Formula(response.data);
    },
    async edit(formula, token, companyId){
        let response = await window.axios.put('/api/formulas/'+formula.id, formula, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Formula(response.data);
    }
}

export default formulasApi